import { useEffect, useRef, useState } from 'react';
import Header from '../../components/Header/Header';
import './Customers.scss';
import { CustomersTableBody } from '../../components/Table/TableBody/TableBody';
import useCustomers from '../../hooks/useCustomers';
import { Loader } from '@piggytechng/component-library';
import ModalSearch from '../../components/Modals/ModalSearch';
import ModalBulkFlagUsers from '../../components/Modals/ModalBulkFlagUsers';
import ModalGenerateStatement from '../../components/Modals/ModalGenerateStatement';
import useRolePermissions from '../../hooks/useRolePermissions';
import useAccountStatement from '../../hooks/useAccountStatement';
import { PiCaretDownBold } from 'react-icons/pi';
import { useOutsideClick } from '../../helpers/utils';
import { GenerateStatementPayload } from '../../types';

const Customers = () => {
  const {
    fetchCustomers,
    isLoading,
    isLoadingMore,
    customersData,
    customersParams,
    setCustomersParams,
    canResetSearch,
  } = useCustomers();
  const [filterModal, setFilterModal] = useState(false);
  const { isLoadingRolesAndPermissions } = useRolePermissions({});

  const [showQuickActions, setShowQuickActions] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkTab, setBulkTab] = useState<'flag' | 'unflag'>('flag');
  const quickActionsRef = useRef(null);
  const quickActionsBtnRef = useRef(null);
  useOutsideClick(quickActionsRef, setShowQuickActions, quickActionsBtnRef);

  const openBulk = (tab: 'flag' | 'unflag') => {
    setBulkTab(tab);
    setShowBulkModal(true);
    setShowQuickActions(false);
  };

  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const { generateAccountStatement, isGeneratingStatement } = useAccountStatement('summary');

  const handleGenerateStatement = (payload: GenerateStatementPayload) =>
    generateAccountStatement(payload, () => setShowGenerateModal(false));

  useEffect(() => {
    localStorage.setItem('activeCustomer', '');
    fetchCustomers();
  }, []);
  useEffect(() => {
    localStorage.setItem('activeCustomer', '');
    fetchCustomers();
  }, []);

  return (
    <>
      <Header name="Customers" />
      <div className="customers-page">
        <div className="customers-page__card">
          {isLoading || isLoadingRolesAndPermissions ? (
            <div className="page-loader">
              <Loader color="#0F60D6" />
            </div>
          ) : (
            <>
              <div className="customers-filter">
                <div className="input-field" onClick={() => setFilterModal(true)}>
                  <input
                    type="text"
                    placeholder="Search customer by user ID, email or phone number"
                    value={customersParams.query}
                  />
                </div>
                {canResetSearch && (
                  <div className="query-filter" onClick={() => fetchCustomers(null, false, true)}>
                    <div></div>
                    <div>Reset</div>
                  </div>
                )}

                <div className="customers-quick-actions">
                  <button
                    ref={quickActionsBtnRef}
                    className="customers-quick-actions__trigger"
                    onClick={() => setShowQuickActions((prev) => !prev)}
                  >
                    Quick Actions
                    <PiCaretDownBold size={15} />
                  </button>
                  {showQuickActions && (
                    <div className="customers-quick-actions__menu" ref={quickActionsRef}>
                      <div onClick={() => openBulk('flag')}>Bulk Flag / Unflag</div>
                      <div
                        onClick={() => {
                          setShowGenerateModal(true);
                          setShowQuickActions(false);
                        }}
                      >
                        Generate Account Statement
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div>
                <CustomersTableBody tableData={customersData.list} isCustomers={true} />
              </div>
              {!isLoading && customersData.list.length < (customersData.total || 0) && (
                <div className="load-more" onClick={() => fetchCustomers(null, true)}>
                  {isLoadingMore ? (
                    <Loader color="#0F60D6" maxWidth="50px" />
                  ) : (
                    <span className="pointer">Show more</span>
                  )}
                </div>
              )}
            </>
          )}
        </div>

        <ModalSearch
          modalIsOpen={filterModal}
          searchContext="search-users"
          data={customersParams}
          setIsOpen={setFilterModal}
          searchDataBy={(filter, empty) => {
            const params = {
              ...customersParams,
              ...filter.users,
            };
            setCustomersParams(params);
            if (!empty) {
              fetchCustomers({ ...params, page: 1 });
            }
          }}
        />

        <ModalBulkFlagUsers modalIsOpen={showBulkModal} setIsOpen={setShowBulkModal} initialTab={bulkTab} />

        <ModalGenerateStatement
          modalIsOpen={showGenerateModal}
          setIsOpen={setShowGenerateModal}
          onSubmit={handleGenerateStatement}
          isLoading={isGeneratingStatement}
          requireUserId
        />
      </div>
    </>
  );
};

export default Customers;
